module.exports = __webpack_public_path__ + "static/media/3DPPA19.71e60f0f.jpg";